import { Component } from "react";
import styled from "styled-components";
import { Select, Spin } from "antd";
import { v4 as uuid } from "uuid";

import { request } from "common/components/request";
import { references } from "common/helpers/references";

import { Placeholder } from "common/components/placeholder";

export class UserSelect extends Component {
    static defaultProps = {
        merchant_ref: void 0,
        user_ref: void 0,
        width: "400px",
        getPopupContainer: () => document.body,
        onChange: () => {}
    };
    
    constructor(props) {
        super(props);
        this.state = {
            users_data: [],
            user_value: props.user_ref && {
                key: props.user_ref
            },
            fetching: false
        };
    }
    
    componentDidMount() {
        this.fetchUsers();
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.props.merchant_ref !== prevProps.merchant_ref) {
            // Load a list of users on this merchant
            this.fetchUsers();
        }
        
        if (this.state.user_value?.key !== prevState.user_value?.key) {
            this.props.onChange(this.state.user_value?.key, prevState.user_value?.key);
        }
        
        if (this.state.user_value?.key && !this.state.user_value?.label && !this.state.users_data.includes(this.state.user_value.key)) {
            this.fetchSingleUser(this.state.user_value.key);
        }
    }
    
    fetchSingleUser = async(user_ref) => {
        this.userFetchId = uuid();
        const fetchId = this.userFetchId;
        
        this.setState({
            user_value: {
                key: user_ref,
                label: (
                    <UsersOption>
                        <div className="name"><Placeholder size="medium" noMargin/></div>
                        <div className="merchant"><Placeholder size="short" noMargin/></div>
                    </UsersOption>
                )
            }
        });
    
        let url = `/users/${user_ref}`;
        if (this.props.merchant_ref) {
            url = `/merchant/${this.props.merchant_ref}/users/${user_ref}`;
        }
        
        const user = await request(url);
        
        if (fetchId !== this.userFetchId) {
            // for fetch callback order
            return;
        }
        
        this.setState({
            user_value: {
                key: user_ref,
                label: (
                    <UsersOption>
                        <div className="name">{user.first_name} {user.last_name}</div>
                        <div className="merchant">{references.toAlias(user.merchant_ref, "merchant")}</div>
                    </UsersOption>
                )
            }
        });
    };
    
    fetchUsers = async(value = "") => {
        let url = "/users";
        if (this.props.merchant_ref) {
            url = `/merchant/${this.props.merchant_ref}/users/`;
        }
        
        this.lastFetchId = uuid();
        const fetchId = this.lastFetchId;
        
        this.setState({
            users_data: [],
            fetching: true
        });
        
        const users = await request(url, {
            data: {
                sort: "last_login",
                order: -1,
                limit: 20,
                name: value
            }
        });
        
        if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
        }
        
        this.setState({
            users_data: (users.results || users).map(({ _id, first_name, last_name, merchant_ref }) => ({
                text: `${first_name} ${last_name}`,
                merchant: references.toAlias(merchant_ref, "merchant"),
                value: _id
            })),
            fetching: false
        });
    };
    
    handleUserChange = (value) => {
        this.setState({
            user_value: value
        });
    };
    
    render() {
        return (
            <StyledSelect
                showSearch
                allowClear
                labelInValue
                filterOption={false}
                value={this.state.user_value}
                placeholder="Select a user"
                notFoundContent={this.state.fetching ? <Spin size="small" /> : void 0}
                onSearch={this.fetchUsers}
                onChange={this.handleUserChange}
                $width={this.props.width}
                getPopupContainer={this.props.getPopupContainer}
            >
                {this.state.users_data.map((d) => (
                    <Select.Option key={d.value}>
                        <UsersOption>
                            <div className="name">{d.text}</div>
                            <div className="merchant">{d.merchant}</div>
                        </UsersOption>
                    </Select.Option>
                ))}
            </StyledSelect>
        );
    }
}

const StyledSelect = styled(Select)`
    width: ${({ $width }) => $width};
`;

const UsersOption = styled.div`
    display: flex;
    width: 355px;

    .loader {
        margin: 8px 0;
    }

    .merchant {
        margin-left: auto;
        color: ${(props) => props.theme.colors["paz-black-l-30"]};
    }
`;
